export default "__VITE_ASSET__CH$5boGX__"